import { Component, EventEmitter, OnInit, Output, ChangeDetectorRef, } from '@angular/core';
import { Router } from '@angular/router';
import { RedliningService } from 'src/app/core/services/redlining.service';
import { Redlining } from 'src/app/core/models/classes/redlining';
import { MatDialog } from '@angular/material/dialog';
import { UserService } from 'src/app/core/services/user.service';
import { DomSanitizer } from '@angular/platform-browser';
import { LogoutComponent } from 'src/app/modules/login/logout/logout.component';
import { SettingsService } from 'src/app/core/services/settings.service';
//import { LogoutService } from 'src/app/modules/services/logout.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})

export class HeaderComponent implements OnInit { //, OnDestroy
  @Output() toggleSideBar: EventEmitter<any> = new EventEmitter();
  todaysRedlingings: Redlining[] = [];
  hasAccess: boolean;
  redliningTodaysCount = 0;
  fileUrl;
  logout: string = '';
  loggedInUser: string = '';

  constructor(
    private router: Router,
    private redService: RedliningService,
    public dialog: MatDialog,
    public userService: UserService,
    private exportimportService: SettingsService,
    private sanitizer: DomSanitizer,
    private changeDetection: ChangeDetectorRef,
    //private logoutService: LogoutService
  ) {}

  ngOnInit(): void {

    this.redService.getTodaysRedlining().subscribe({
      next: (red) => {
        this.todaysRedlingings = red;
        this.redliningTodaysCount = this.todaysRedlingings.length;
      },
      error: (err) => {
        throw Error(err.Status);
      },
    });
    this.userService
      .getUserProfile(+localStorage.getItem('loginId'))
      .subscribe({
        next: (data) => {
          if (data !== undefined) {
            this.loggedInUser = `${data.firstName} ${data.lastName}`;
          }
        },
      });
    this.userService.getUserRole(+localStorage.getItem('loginId')).subscribe({
      next: (data) => {
        if (data !== 3) {
          this.hasAccess = true;
        }
      },
    });
    this.exportimportService.exportSettings().subscribe({
      next: (data: any) => {
        var setting = JSON.stringify(data);
        const blob = new Blob([setting], { type: 'application/json' });
        this.fileUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
          window.URL.createObjectURL(blob)
        );
      },
    });
    this.logout = $localize`LogOut`;
  }

  onSignOut(): void {
    localStorage.clear();
    this.router.navigate(['']);
    //  this.dialog.open(LogoutComponent, {
    //       data: '',
    //       panelClass: 'custom-dialog-container',
    //     });
  }

  onExport() {}
}
